import React, { Component } from 'react'

import axios from 'axios';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button';

import pink from "@material-ui/core/colors/pink";
import orange from "@material-ui/core/colors/orange";

// Material Icons Imports
import EditIcon from '@material-ui/icons/Edit';
import IconDevices from '@material-ui/icons/School';
import IconVisibility from '@material-ui/icons/Visibility';
import IconSave from '@material-ui/icons/SaveAlt';
import IconArchive from '@material-ui/icons/ArchiveOutlined';
import IconUnarchive from '@material-ui/icons/UnarchiveOutlined';
import Tooltip from '@material-ui/core/Tooltip';


// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Assets imports

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Moment
import moment from 'moment';

import _ from 'lodash';

//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const orange200 = orange['200'];
const pink400 = pink['400'];

const styles = {
  avatar: {
    size: 30,
    margin: 10,
    color: orange200,
    backgroundColor: pink400,
  },
  certificateActions: {
    marginLeft: 'auto',
    marginRight: 0
  },
};


class Certificate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      download: null,
      show: null,
      open: false,
      edit: null
    }

  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  _createCertificateLinks(certificate, action) {
    const pdfUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/users/' + certificate.userId + '/certificate/' + certificate.id
    console.log(pdfUrl)
    axios.get(pdfUrl,
      {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      })
      .then((response) => {
        const fileExtension = _.last(certificate.baseFileName.split('.'))
        let type;
        if (fileExtension === 'pdf') {
          type = 'application/pdf'
        } else {
          type = `image/${fileExtension}`
        }
        const url = window.URL.createObjectURL(new Blob([response.data],
          { type: type }));
        const link = document.createElement('a');
        link.href = url;
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', certificate.baseFileName);
        link.target = '_blank';
        document.body.appendChild(link);
        document.body.appendChild(linkDownload);
        this.setState({
          url: url,
          download: linkDownload,
          show: link
        })
        this.state[action].click()
      })
      .catch((error) => console.log(error));
  }

  _createEditAction(certificate, action) {
    const editLink = document.createElement('a');
    editLink.href = `/users/certificate/${this.props.certificate.id}/edit`
    // editLink.href = '/users/certificate/test/edit'
    // to={`/users/${this.state.selectedId}/edit`}
    document.body.appendChild(editLink);
    this.setState({
      edit: editLink
    })
    editLink.click();
  }

  _handleClick(certificate, action) {
    if (this.state[action]) {
      this.state[action].click()
    } else if(action === 'edit') {
      this._createEditAction(certificate, action)
    } else {
      this._createCertificateLinks(certificate, action)
    }
  }
  async _handleArchive(certificate, markedAsDeleted, handler) {
    const certificateId = certificate.id;
    await this.props.mutation_mark_as_deleted({
      variables: {
        certificateId,
        markedAsDeleted
      }
    })
      .then(this.handleClose)
      .then(handler)
      .catch((e) => { console.log(e) })
  }

  render() {
    const { classes, certificate, handler } = this.props;
    const icon = certificate.markedAsDeleted ? <IconUnarchive /> : <IconArchive />
    const action = certificate.markedAsDeleted ? 'Unarchive' : 'Archive'
    const message = certificate.markedAsDeleted ? 'This action will restore the certificate to the appropiate section' : "Archived certificates only appears on the owner's profile"
    const isAdmin = localStorage.current_user_role === 'Admin'
    return (
      <div><ListItem>
        <Avatar
          className={classes.avatar}
        ><IconDevices /></Avatar>
        <ListItemText primary={certificate.certification.name}
          secondary={'Expiry Date: ' + moment(certificate.expiryDate).format('DD-MM-YYYY')}></ListItemText>
        <div className={classes.certificateActions}>
          <Tooltip title="Show">
            <IconButton onClick={() => this._handleClick(certificate, 'show')}>
              <IconVisibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton onClick={() => this._handleClick(certificate, 'download')}>
              <IconSave />
            </IconButton>
          </Tooltip>
          <Tooltip title={certificate.markedAsDeleted ? "Unarchive" : " Archive"}>
            <IconButton onClick={this.handleClickOpen}>
              {icon}
            </IconButton>
          </Tooltip>
          { isAdmin ? (
            <Tooltip title="Edit">
              <IconButton onClick={() => this._handleClick(certificate, 'edit')}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          ) : (null)}
        </div>
      </ListItem>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{action} the {certificate.certification.name} certificate?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this._handleArchive.bind(this, certificate, !certificate.markedAsDeleted, handler)} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const MUTATION_MARK_AS_DELETED = gql`
mutation updateCertificate($certificateId: ID!, $markedAsDeleted: Boolean!){
    updateCertificate(certificateId: $certificateId, input:{markedAsDeleted:$markedAsDeleted}){
    id
  }
}
`;

Certificate.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  graphql(MUTATION_MARK_AS_DELETED, {
    name: 'mutation_mark_as_deleted',
    options: {
      refetchQueries: ["all_certifications_query"]
    }
  }),
  withStyles(styles)
)(Certificate)


// WEBPACK FOOTER //
// src/components/innerComponents/Certificate.js